import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-squares',
  templateUrl: './info-squares.component.html',
  styleUrls: ['./info-squares.component.scss']
})
export class InfoSquaresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
